<div>
  <span class="center text-neutral">{{ 'reservations.number-message' | translate }} </span>
  <div class="chip-container">
    @for (numberOption of numbers; track trackByNumber($index, numberOption)) {
      <button
        class="chip-button"
        [ngClass]="{'selected': selected === numberOption}"
        (click)="onSelection(numberOption)"
        >
        <p-chip>
          {{ numberOption }}
        </p-chip>
      </button>
    }
  </div>
</div>